import * as Yup from 'yup';
import { password } from './create';

const createValidationSchema = () =>
  Yup.object().shape({
    password,
  });

export default createValidationSchema;
